/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as channelExpress from '../../channelExpress';
import {authError} from './auth';

function startAction() {
  return {type: 'START'};
}

function startFailureAction(error) {
  return {
    type: 'START_FAILURE',
    error: {
      error: error,
      message: error.message
    },
    title: 'Unable to Start Viewing Channel'
  };
}

function stopAction(sessionId) {
  return {
    type: 'STOP',
    sessionId
  };
}

function start() {
  return function(dispatch) {
    let timeout = null;

    try {
      channelExpress.start((error) => {
        if (timeout !== null) {
          clearTimeout(timeout);

          timeout = null;
        }

        return dispatch(authError(error.message));
      });

      return dispatch(startAction());
    } catch (e) {
      return dispatch(startFailureAction(e));
    }
  };
}

function stop() {
  return function(dispatch) {
    channelExpress.stop();

    return dispatch(stopAction());
  };
}

export {start, stop};